import { useDeviceFormat } from "@/hooks/useDeviceFormat";
import { appSurfaceProperties } from "@/lib/analytics-surface";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

/**
 * Keeps the app surface on every PostHog event in step with the tree on
 * show: a window resized across the breakpoint switches trees, and the events
 * after it say so. Registered first at init, for the first pageview.
 */
export function useAppSurfaceAnalytics(): void {
  const posthog = usePostHog();
  const { isMobile } = useDeviceFormat();

  useEffect(() => {
    posthog?.register(appSurfaceProperties(isMobile));
  }, [posthog, isMobile]);
}
